import { useState, useEffect } from 'react';
import axios from 'axios';

// Use environment variable for API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export function usePriceData() {
  const [priceData, setPriceData] = useState<Array<{ time: string; value: number }>>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPriceData = async () => {
      try {
        setLoading(true);
        
        const response = await axios.get(`${API_BASE_URL}/prices`);
        
        // Transform data to the format expected by the chart
        const transformed = response.data.map((item: any) => ({
          time: item.date.split('T')[0],
          value: Number(item.close)
        }));
        
        setPriceData(transformed);
        setError(null);
      } catch (err) {
        console.error("Error fetching price data:", err);
        setError(err instanceof Error ? err : new Error('Failed to fetch price data'));
      } finally {
        setLoading(false);
      }
    };

    fetchPriceData();
  }, []);

  return { priceData, loading, error };
}
